.row {
  height: 4.8rem;
  background: var(--color-grayscale-tuna);
}

.block-editable-text {
  width: 100%;
}

.block-name {
  width: 100%;
  height: 3.2rem;
  padding: 0.8rem;
  text-align: center;
}

.row-mirror {
  display: grid;
  grid-template-columns: 8.5% 9.2% 8.3% 7.4% 25.7% 26.5% 4.6% 5.4% 4.4%;
  position: relative;
  align-items: center;

  // substitute border on parent, adding 0.3rem to width
  margin: 0px -0.15rem;
}

.cell-mirror {
  padding-inline-end: 1.6rem;

  &:nth-child(2) {
    grid-column-start: 7;
  }

  &:last-child {
    justify-self: end;
    padding-inline-end: 1.75rem;
    width: -webkit-fill-available;
  }
}
